import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { baseUrl } from "../../../enum/constant";

const BankInfo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("SEPA");
  const dropdownRef = useRef();
  const [formData, setFormData] = useState({
    bank_name: "",
    account_number: "",
    bic_swift: "",
    bank_address: "",
    supported_payments: [], // <-- as array for multi-select UI
    company_name: "",
    company_address: "",
    user_id: "",
  });

  const options = ["SEPA", "SWIFT"];

  const handleSelect = (value) => {
    setSelected(value);
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const userId = localStorage.getItem("userId");

    if (userId) {
      setFormData((prevState) => ({
        ...prevState,
        user_id: userId,
      }));

      const fetchBankInfo = async () => {
        try {
          const base = baseUrl;
          const response = await axios.get(
            `${base}api/bank-info/show/${userId}`
          );
          if (response.data) {
            setFormData((prevState) => ({
              ...prevState,
              ...response.data,
              supported_payments: response.data.supported_payments
                ? response.data.supported_payments.split(",")
                : [], // Convert string to array for select field
            }));
          }
        } catch (error) {
          console.error("Error fetching bank info:", error);
        }
      };
      fetchBankInfo();
    } else {
      setError("User is not logged in.");
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, options, multiple } = e.target;

    if (multiple) {
      const values = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);

      setFormData({
        ...formData,
        [name]: values,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formData,
        supported_payments: formData.supported_payments.join(","),
      };

      const base = baseUrl;
      const response = await axios.post(base + "api/bank-info", payload);

      setMessage("Bank information saved successfully!");
      window.scrollTo(0, 0);
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Error submitting form data:", error);
      if (error.response) {
        setError(
          `Error: ${error.response.data.message || error.response.statusText}`
        );
      } else if (error.request) {
        setError("Error: No response from server.");
      } else {
        setError("Error submitting form data.");
      }
      window.scrollTo(0, 0);
      setTimeout(() => setError(""), 3000);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <h5 className="mb-3">Bank Information</h5>
        {error && (
          <div className={`cus-alert-msg alert-danger`} role="alert">
            <div class="icon">✖</div>
            <p class="message mb-0">{error}</p>
          </div>
        )}
        {message && (
          <div className="cus-alert-msg  alert-success" role="alert">
            <div class="icon">✔</div>
            <p class="message mb-0">{message}</p>
          </div>
        )}
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <div className="fm-group">
              <div className="field-bg">
                <label className="form-label">Bank Name</label>
                <input
                  type="text"
                  value={formData.bank_name}
                  onChange={handleChange}
                  required
                  name="bank_name"
                  className="form-control"
                  placeholder="e.g. Deutsche Bank AG"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="fm-group">
              <div className="field-bg">
                <label className="form-label">Bank Address</label>
                <input
                  type="text"
                  value={formData.bank_address}
                  onChange={handleChange}
                  required
                  name="bank_address"
                  className="form-control"
                  placeholder="Street, city, ZIP code"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="fm-group">
              <div className="field-bg">
                <label className="form-label">Bank Account Number</label>
                <input
                  type="text"
                  value={formData.account_number}
                  onChange={handleChange}
                  required
                  name="account_number"
                  className="form-control"
                  placeholder="IBAN or local account number"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="fm-group">
              <div className="field-bg">
                <label className="form-label">BIC/Swift</label>
                <input
                  type="text"
                  value={formData.bic_swift}
                  onChange={handleChange}
                  name="bic_swift"
                  required
                  className="form-control"
                  placeholder="International code (e.g. DEUTDEFF)"
                />
              </div>
            </div>
          </div>
        </div>

        <h5 className="mb-3">Payments</h5>
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <div className="fm-group">
              <div className="field-bg">
                <label className="form-label">Supported Payment</label>

                <div
                  ref={dropdownRef}
                  className="position-relative  rounded    d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer", userSelect: "none" }}
                  onClick={() => setIsOpen((prev) => !prev)}
                >
                  <span>{selected}</span>
                  <img
                    src="assets/images/drop-down.png"
                    alt="dropdown"
                    style={{
                      width: "40px",
                    }}
                  />
                  {isOpen && (
                    <div
                      className="position-absolute bg-white shadow border rounded mt-2"
                      style={{
                        top: "100%",
                        left: 0,
                        width: "100%",
                        zIndex: 1000,
                      }}
                    >
                      {options.map((opt) => (
                        <div
                          key={opt}
                          onClick={() => handleSelect(opt)}
                          className="px-3 py-2 hover:bg-light"
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selected === opt ? "#f1f1f1" : "transparent",
                          }}
                        >
                          {opt}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Hidden input for form submit */}
                <input
                  type="hidden"
                  name="supported_payments"
                  value={selected}
                />
              </div>
            </div>
          </div>
        </div>

        <h5 className="mb-3">Company Information</h5>
        <div className="mb-3">
          <div className="fm-group">
            <div className="field-bg">
              <label className="form-label">Company Name</label>
              <input
                type="text"
                value={formData.company_name}
                onChange={handleChange}
                required
                name="company_name"
                className="form-control"
                placeholder="Registered legal name"
              />
            </div>
          </div>
        </div>
        <div className="mb-4">
          <div className="fm-group">
            <div className="field-bg">
              <label className="form-label">Company Address</label>
              <input
                value={formData.company_address}
                onChange={handleChange}
                required
                name="company_address"
                type="text"
                className="form-control"
                placeholder="Head office location"
              />
            </div>
          </div>
        </div>

        <div className="text-center">
          <button type="submit" className="save-btn">
            Save/Update
          </button>
        </div>
      </form>
    </>
  );
};

export default BankInfo;
